import ui from "./_ui";
import error from "./_error";
import language from "./_language";
import message from "./_message";

export default {
  ui: ui,
  error: error,
  language: language,
  message: message
};
